const Fonts = {
  getSignika: () => 'Signika',
  getHalisR: () => 'HalisR',
};
export default Fonts;
